import FacetDrawer from '@islands/facet-drawer';

class FacetBar extends HTMLElement {
  drawer: FacetDrawer | null = null;
  toggleBtn: HTMLElement | null = null;

  connectedCallback() {
    this.drawer = document.querySelector('facet-drawer') as FacetDrawer;
    this.toggleBtn = this.querySelector('#facet-toggle');

    this.toggleBtn?.addEventListener('click', () => {
      this.drawer?.show();
    });
  }
}

if (!customElements.get('facet-bar')) {
  customElements.define('facet-bar', FacetBar);
}
